import { ClickAwayListener, Drawer } from '@material-ui/core'
import { newProjectActions } from 'features/BillOfMaterials/store/newProjectReducer'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from 'store/configureStore'
import { BomItemDetail } from './BomItemDetails/BomItemDetail'
import { useBomItemDetailsDrawerStyles } from './BomItemDetailsDrawer.styles'
import { BomItemDetailsDrawerHeader } from './BomItemDetailsDrawerHeader'

export type BomItemDetailsDrawerProps = {
  bomItemId: string
  bomItemType: BoMItemType
  onClose: () => void
  detailTabIndex?: number
}

const minWidth = 850
const maxWidth = document.body.clientWidth * 0.85

export const BomItemDetailsDrawer = (props: BomItemDetailsDrawerProps) => {
  const sharedClasses = useBomItemDetailsDrawerStyles()
  const dispatch = useAppDispatch()

  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
    dispatch(newProjectActions.setBomItemInSearch(null))
    props.onClose()
  }

  const [resizing, setResizing] = useState(false)
  // const width = useRef(250)
  const containerRef = useRef<HTMLDivElement>(undefined)

  useEffect(() => {
    const handleResize = (e) => {
      if (resizing) {
        const sizeInPx = document.body.clientWidth - e.clientX

        if (sizeInPx > maxWidth || sizeInPx < minWidth) {
          document.body.style.cursor = 'not-allowed'
        } else {
          document.body.style.cursor = 'ew-resize'
          containerRef.current.style.width = `${sizeInPx}px`
        }
      }
    }

    document.addEventListener('mousemove', handleResize)

    if (!resizing) {
      document.removeEventListener('mousemove', handleResize)
      document.body.style.cursor = 'unset'
    }

    return () => {
      document.removeEventListener('mousemove', handleResize)
    }
  }, [resizing])

  if (props.bomItemId === undefined) {
    props.onClose()
    return null
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      variant="persistent"
      anchor="right"
      id="financial-details-drawer"
    >
      <ClickAwayListener onClickAway={() => setResizing(false)}>
        <div
          className={sharedClasses.resizeBorder}
          onMouseDown={(e) => {
            e.preventDefault()
            setResizing(true)
          }}
          onMouseUp={(e) => {
            e.preventDefault()
            setResizing(false)
          }}
          onDoubleClick={(e) => {
            e.preventDefault()
            containerRef.current.style.width =
              containerRef.current.clientWidth > maxWidth * 0.85
                ? `${minWidth}px`
                : `${maxWidth}px`
          }}
        />
      </ClickAwayListener>

      <div
        className={sharedClasses.container}
        ref={containerRef}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className={sharedClasses.header}>
          <BomItemDetailsDrawerHeader
            bomItemId={props.bomItemId}
            bomItemType={props.bomItemType}
            handleClose={handleClose}
          />
        </div>
        <BomItemDetail
          bomItemId={props.bomItemId}
          bomItemType={props.bomItemType}
          detailTabIndex={props.detailTabIndex}
        />
      </div>
    </Drawer>
  )
}
